<app-split-pane
  storageKey="split.kpis"
  [initialLeftRatio]="0.7"
  [collapseBreakpointPx]="1024"
  [collapsedOnSmallScreens]="true"
>
  <ng-container left>
    <app-split-pane-vertical storageKey="split.kpis.left" [initialTopRatio]="0.7">
      <ng-container top>
        <app-chat [suggestions]="kpiSuggestions" [context]="kpiContext" placeholder="Ask about KPIs..."></app-chat>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="kpis.chat"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>

  <ng-container right>
    <app-split-pane-vertical storageKey="split.kpis.right" [initialTopRatio]="0.7">
      <ng-container top>
        <div class="page-workspace">
          <section class="card shadow-sm border-0 p-3 p-md-4">
            <h2 class="h4 mb-1">KPIs</h2>
            <p class="text-muted mb-3">Define KPI ownership and publish a focused delivery improvement plan.</p>
            <h3 class="h5 mb-3">KPI Planning</h3>
            <div class="row g-3">
              <div class="col-md-4">
                <label class="form-label">KPI name</label>
                <input class="form-control" [(ngModel)]="kpiDraft.kpiName" placeholder="e.g. Sprint predictability" />
              </div>
              <div class="col-md-4">
                <label class="form-label">Target value</label>
                <input class="form-control" [(ngModel)]="kpiDraft.targetValue" placeholder="e.g. >= 90%" />
              </div>
              <div class="col-md-4">
                <label class="form-label">Owner</label>
                <input class="form-control" [(ngModel)]="kpiDraft.owner" placeholder="e.g. Delivery manager" />
              </div>
              <div class="col-12">
                <label class="form-label">Remediation plan</label>
                <textarea class="form-control" rows="3" [(ngModel)]="kpiDraft.remediationPlan" placeholder="Steps if KPI is off-target..."></textarea>
              </div>
            </div>
            <div class="mt-3">
              <button class="btn btn-primary" type="button" [disabled]="publishingKpi" (click)="publishKpiPlan()">
                @if (publishingKpi) {
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  Publishing...
                } @else {
                  Publish KPI Plan
                }
              </button>
            </div>
            @if (kpiError) {
              <div class="alert alert-danger mt-3 mb-0">{{ kpiError }}</div>
            }
            @if (kpiSuccess) {
              <div class="alert alert-success mt-3 mb-0">{{ kpiSuccess }}</div>
            }
          </section>

          <section class="card shadow-sm border-0 p-3 p-md-4">
            <h3 class="h5 mb-3">KPI Summary</h3>
            @if (!hasPublishedKpi) {
              <div class="small text-muted">No KPI plan published yet. Publish plan to populate summary.</div>
            } @else {
              <div class="summary-grid">
                <article class="summary-card">
                  <div class="summary-label">KPI</div>
                  <div class="summary-value">{{ kpiDraft.kpiName }}</div>
                </article>
                <article class="summary-card">
                  <div class="summary-label">Target</div>
                  <div class="summary-value">{{ kpiDraft.targetValue }}</div>
                </article>
                <article class="summary-card">
                  <div class="summary-label">Owner</div>
                  <div class="summary-value">{{ kpiDraft.owner }}</div>
                </article>
                <article class="summary-card summary-card--full">
                  <div class="summary-label">Remediation</div>
                  <div class="summary-value">{{ kpiDraft.remediationPlan.trim() || 'No remediation plan provided.' }}</div>
                </article>
              </div>
            }
          </section>
        </div>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="kpis.main"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>
</app-split-pane>
